<template>
  <div class="columns response-rate">
    <!-- Response Rate Begins -->
    <div class="column has-text-centered is-one-third">
      <span class="response-rate-percentage"><b>
          <animated-number
            :duration="500"
            :formatValue="formatStats"
            :value="calculateRatesBreakdown(responseRates.avgResponseCount)"
          >
          </animated-number>%</b><div>Response rate</div>
      </span>
    </div> <!-- Response Rate Ends -->
    <!-- Response Rate Breakdown Begins -->
    <div class="column">
      <div class="breakdown-row" v-for="response in responseRates.intervalBreakdown">
        <span class="br__percent">
          <animated-number
            :duration="500"
            :value="calculateRatesBreakdown(response.count)"
            :formatValue="formatStats"
          ></animated-number>%
        </span>
        <progress
          max="100"
          :value="calculateRatesBreakdown(response.count)"
          :class="['progress is-basic', { 'is-small': true }]"
        >
          {{ calculateRatesBreakdown(response.count) }}&#37;
        </progress>
        <span class="br__interval">{{ response.interval }}</span>
      </div>
    </div> <!-- Response Rate Breakdown Ends -->
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'

export default {
  name: 'ResponseRateWidget',
  components: {
    AnimatedNumber
  },
  props: {
    responseRates: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Format the float numbers upto two digits after decimal
     * @param {string} value Value of stat
     * @return {string|integer}
     */
    formatStats (value) {
      return !Number.isInteger(value) ? `${Number(value).toFixed(2)}` : value
    },
    /**
     * Calculate the rates for breakdown
     * @param {number} value Value of stat
     * @return {number}
     */
    calculateRatesBreakdown (value) {
      let rate = (value * 100) / this.responseRates.totalReviews
      return !isNaN(rate) ? rate : 0
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.response-rate {
  width: 419px;
  height: 101px;
  border: solid 1px rgba(88, 89, 91, 0.32);
}

.response-rate .column {
  margin: auto 0;
  padding: 0;
}

.response-rate-percentage b {
  line-height: 1.38;
  letter-spacing: normal;
  color: #58595b;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  font-size: 24px;
}

.response-rate-percentage div {
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.progress::-webkit-progress-value {
  transition: width 0.8s ease;
}

@mixin progress-bar() {
  background-color: color('blue');
}

.progress.is-basic::-webkit-progress-value {
  @include progress-bar
}

.progress.is-basic::-moz-progress-bar {
  @include progress-bar
}

.progress.is-basic::-ms-fill {
  @include progress-bar
}

/* Media Queries begins */
/* Media Query For Tablet */
@media screen and (min-width: 767px) {
  .response-rate {
    margin-left: 1%;
    width: auto;
  }
  .response-rate-percentage b {
    font-size: 11px;
  }
  .response-rate .is-one-third {
    width: 21%;
  }
}

/* Media Query For Desktop and Big Screens */
@media screen and (min-width: 1280px) {
  .response-rate {
    width: 419px;
    margin-left: 0;
  }
  .response-rate-percentage b {
    font-size: 24px;
  }
  .response-rate .is-one-third {
    width: 33.33%;
  }
}
/* Media Queries ends */

.breakdown-row {
  line-height: 0;
  margin-bottom: 1px;

  .br__percent {
    font-size: 10px !important;
    color: #58595b;
    text-align: right;
    width: 37px;
    display: inline-block;
    line-height: normal;
  }

  progress {
    width: 151px;
    height: 11px;
    border-radius: 0;
    display: inline-block;
    margin-bottom: 1px;
    margin-right: 3px;
    margin-left: 4px;

    @media screen and (max-width: 1279px) {
      margin-right: 0;
    }
  }

  .br__interval {
    font-size: 10px;
    color: #58595b;

    @media screen and (max-width: 1279px) {
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/ResponseRateWidget.vue